import React from 'react';
type YesNoInputProps = {
  value: boolean | null;
  onChange: (v: boolean) => void;
};
export function YesNoInput({
  value,
  onChange
}: YesNoInputProps) {
  return <div className="flex flex-col sm:flex-row gap-3" data-id="element-68">
      <Option label="Yes" selected={value === true} onClick={() => onChange(true)} data-id="element-69" />
      <Option label="No" selected={value === false} onClick={() => onChange(false)} data-id="element-70" />
    </div>;
}
type OptionProps = {
  label: string;
  selected: boolean;
  onClick: () => void;
};
function Option({
  label,
  selected,
  onClick
}: OptionProps) {
  return <button type="button" onClick={onClick} className={`inline-flex items-center justify-center px-7 sm:px-8 py-2.5 sm:py-3 rounded-full border transition-all text-base sm:text-lg ${selected ? 'bg-white text-black border-white' : 'bg-transparent text-white border-white/40 hover:border-white hover:bg-white/5'}`} data-id="element-71">
      {label}
    </button>;
}